document.addEventListener("DOMContentLoaded", () => {
$.fn.wc_gc_datepickers = function() {

  var $datepickers = $( this ).find( '.datepicker' );

  $datepickers.each( function( index ) {

    // Cache local instances.
    var $datepicker       = $( this ),
      $container        = $datepicker.parent(),
      $timestamp_input  = $container.find( 'input[name="wc_gc_giftcard_delivery"]' ),
      $offset_gmt_input = $container.find( 'input[name="_wc_gc_giftcard_delivery_gmt_offset"]' );

    // Make Template backwards compatible.
    if ( ! $offset_gmt_input.length ) {
      $offset_gmt_input = $( '<input/>' );
      $offset_gmt_input.attr( 'type', 'hidden' );
      $offset_gmt_input.attr( 'name', '_wc_gc_giftcard_delivery_gmt_offset' );
      $container.append( $offset_gmt_input );
    }

    // Fill GMT offset.
    var now           = new Date(),
      gmt_offset    = parseFloat( wc_gc_params.gmt_offset, 10 ),
      client_offset = now.getTimezoneOffset() / 60,
      datepicker_min_date;

    var diff = client_offset - gmt_offset;

    if ( 'default' === wc_gc_params.date_input_timezone_reference ) {

      $offset_gmt_input.val( client_offset );
      datepicker_min_date = '+1D';

    } else if ( 'store' === wc_gc_params.date_input_timezone_reference ) {

      var hours_now     = now.getHours() + now.getMinutes() / 60,
        day_factor    = hours_now + diff,
        datepicker_min_date;

      $offset_gmt_input.val( gmt_offset );

      if ( day_factor >= 24 ) {
        datepicker_min_date = '+' + ( Math.floor( day_factor / 24 ) + 1 ) + 'D';
      } else if ( day_factor <= 0 ) {
        datepicker_min_date = 0;
      } else {
        datepicker_min_date = '+1D';
      }
    }

    // Init datepicker.
    $datepicker.datepicker( {
      beforeShow: function( input, el ) {
        $('#ui-datepicker-div').removeClass( 'wc_gc_datepicker' );
        $('#ui-datepicker-div').addClass( 'wc_gc_datepicker' );
      },
      minDate: datepicker_min_date,
      dateFormat: "d MM yy"
    } );

    // Fill hidden inputs with selected date if any.
    var currentDate = $datepicker.datepicker( 'getDate' );
    if ( null !== currentDate && typeof currentDate.getTime === 'function' ) {

      // Append current time.
      currentDate.setHours( now.getHours(), now.getMinutes() );

      if ( 'store' === wc_gc_params.date_input_timezone_reference ) {
        currentDate = addMinutes( currentDate, -1 * client_offset * 60 );
        currentDate = addMinutes( currentDate, gmt_offset * 60 );
      }

      $timestamp_input.val( currentDate.getTime() / 1000 );
    }

    // On Change.
    $datepicker.on( 'change', function() {

      var selectedDate = $datepicker.datepicker( 'getDate' );
      if ( null !== selectedDate && typeof selectedDate.getTime === 'function' ) {

        // Append current time.
        var now = new Date();
        selectedDate.setHours( now.getHours(), now.getMinutes() );

        if ( 'store' === wc_gc_params.date_input_timezone_reference ) {
          selectedDate = addMinutes( selectedDate, -1 * client_offset * 60 );
          selectedDate = addMinutes( selectedDate, gmt_offset * 60 );
        }

        $timestamp_input.val( selectedDate.getTime() / 1000 );

      } else {
        $timestamp_input.val( '' );
      }

    } );

  } );
};

})